import React, { useState } from "react";
import { useNavigate, Navigate } from 'react-router-dom'
import { baseUrl } from "../../shared";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import Input from '@mui/material/Input';
import Table from '@mui/material/Table';
import TableHead from "@mui/material/TableHead";
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';

const initialRow = {
  capacity: ''
};

const emptyRow = {
  capacity: ''
};

const getEmptyRow = () => ({
  capacity: ''
});

export default function CapacityBulk() {
  const [rows, setRows] = useState([initialRow]);
  const [rowErrors, setRowErrors] = useState([]);

  const handleChange = (index, field, value) => {
    const newRows = [...rows];
    newRows[index][field] = value;
    setRows(newRows);
  };

  const addRow = () => {
    setRows([...rows, { ...emptyRow }]);
  };

  const fieldOrder = [
    'capacity'
  ];


  const handleRemoveRow = (indexToRemove) => {
    setRows(prevRows => {
      const newRows = prevRows.filter((_, index) => index !== indexToRemove);

      if (newRows.length === 0) {
        return [getEmptyRow()]; // ⬅️ Replace with empty row if last one deleted
      }

      return newRows;
    });

    setRowErrors(prevErrors => {
      const newErrors = prevErrors.filter((_, index) => index !== indexToRemove);

      if (newErrors.length === 0) {
        return [{}]; // ⬅️ Also reset errors
      }

      return newErrors;
    });
  };


  const handlePaste = (event) => {
    event.preventDefault();
    const pastedText = event.clipboardData.getData('text/plain');
    const rows = pastedText.trim().split('\n').map(row => row.split('\t'));

    let hasHeader = false;
    const firstRow = rows[0].map(cell => cell.toLowerCase().replace(/\s+/g, ''));

    // Detect header row
    const expectedHeaders = fieldOrder.map(f => f.toLowerCase().replace(/[^a-z]/g, ''));
    const headerMatchCount = firstRow.filter(cell => expectedHeaders.includes(cell)).length;

    if (headerMatchCount === 1) {
      hasHeader = true;
    }

    const dataRows = hasHeader ? rows.slice(1) : rows;

    const newRows = dataRows.map((cols) => {
      const rowObj = {};

      fieldOrder.forEach((key, idx) => {
        let val = cols[idx] || '';

        rowObj[key] = val.toUpperCase();
      });

      return rowObj;
    });

    setRows(prev => [...prev, ...newRows]);
  };

  function validateAllRows(rows) {
  const newErrors = [];

  rows.forEach((row, index) => {
    const rowErrors = {};

    if (!row.capacity?.trim()) {
      rowErrors.capacity = 'Required';
    }

    newErrors.push(rowErrors);
  });

  setRowErrors(newErrors);

  return newErrors.every((e) => Object.keys(e).length === 0);
}

  const handleSubmit = () => {

    const allValid = validateAllRows(rows);

    if (!allValid) {
      alert('Some rows have invalid values. Please fix them first.');
      console.log("Here: ",rowErrors)
      return;
    }
    const errors = [];

    rows.forEach((row, index) => {
      const missingFields = Object.entries(row).filter(([key, value]) => {
        const isEmpty = value === '' || value === null || value === undefined;

        return isEmpty;
      });

      if (missingFields.length > 0) {
        errors.push({
          row: index + 1,
          fields: missingFields.map(([key]) => key),
        });
      }
    });

    if (errors.length > 0) {
      console.warn('Validation errors:', errors);

      alert(
        `Please fill all fields.\n\n` +
        errors.map(e => `Row ${e.row}: Missing ${e.fields.join(', ')}`).join('\n')
      );

      return;
    }
    uploadBulk(rows);
  };

async function uploadBulk(e) {
  console.log('rows: ', rows)
  console.log('e: ',e)
    const url = baseUrl + "upload/capacities";
    await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': "application/json",
        'username': localStorage.getItem('username'),
        'bToken': localStorage.getItem('bToken')
      },
      body: JSON.stringify(rows),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log(data[0])
        if (data[0].status === 200) {
          setMessage(data[0].message);
          setOpen(true);
        } else if (data[0].status === 401) {
          setMessage(data[0].message);
          setOpen(true);
        }
      })
      .catch((err) => {
        setMessage(err.message);
        setOpen(true);
      });
  }

  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  const handleClose = () => {
    <Navigate to={'/admin/'} />
    { navigate(0) }
  };

  return (
    <div className="bulkAsset">
      <React.Fragment>
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle>
            Capacity Bulk Upload
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              {message}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose}>Ok</Button>
          </DialogActions>
        </Dialog>
      </React.Fragment>
      <>
        <TextField
          label="Paste rows from Excel here"
          variant="outlined"
          onPaste={handlePaste}
          placeholder="Paste data with or without headers"
          fullWidth
          sx={{ mb: 2 }}
          multiline
        />
        <TableContainer component={Paper}>
          <Table aria-label="simple table" sx={{ width: '100%' }}>
            <TableHead>
              <TableRow>
                <TableCell>
                  <IconButton onClick={() => addRow()}><AddCircleOutlineOutlinedIcon /></IconButton>
                </TableCell>
                {[
                  'Capacity'
                ].map((header) => (
                  <TableCell key={header} sx={{ fontSize: '0.8rem' }}>{header}</TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((row, index) => (
                <TableRow key={index}>
                  <TableCell>
                    <IconButton onClick={() => handleRemoveRow(index)} aria-label="delete">
                      <DeleteIcon />
                    </IconButton>
                  </TableCell>
                  <TableCell>
                    <Input
                      style={{ minWidth: '175px', blockSize: '0.8rem' }}
                      error={!!rowErrors[index]?.capacity}
                      value={row.capacity}
                      onChange={(e) => handleChange(index, 'capacity', e.target.value)}
                    />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </>
      <>
        <Button onClick={handleSubmit} variant="contained" style={{ marginLeft: 'auto', display: 'block' }}>Submit</Button>
      </>
    </div>
  );
}